// extracted by mini-css-extract-plugin
export default {"loginForm":"PfwHuPLigSxMB8i2ywBx","loginBtnWrapper":"_KPr9s4rQrthh6AoWgPA"};